import React from 'react'
import { connect } from 'react-redux'
import $ from 'jquery'

import { clearNoDataError } from '../../GlobalStateContainer/actions'

import { fetchReportingError, fetchReportingList, export_excel_bridge_reporting  } from './actions'

import ProgressBar from './ProgressBar'
import LoadingSpinner from './LoadingSpinner'
import CommError from '../../Shared/Errors/Errors'
import ConfirmModal from '../../Shared/ConfirmModal/ConfirmModal'

import './Reporting.css'

var Spinner = require('react-spinkit');

class Reporting extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            page: 1,
            sortBy: "",
            sortOrder: "Unspecified",
            advancedFilterChosen: false,
            templateValue: '0',
            manufacturerValue: '0',
            productLineValue: '0'
        };

        this.fetchReportingErrorClear = this.fetchReportingErrorClear.bind(this);
        this.errorNoDataClear = this.errorNoDataClear.bind(this);

        this.sortColumn = this.sortColumn.bind(this);

        this.enterKey = this.enterKey.bind(this);
        this.setFilter = this.setFilter.bind(this);
        this.setFilterData = this.setFilterData.bind(this);
        this.clearFilters = this.clearFilters.bind(this);

        this.export_reporting = this.export_reporting.bind(this);

        this.loadMore = this.loadMore.bind(this);
    }

    fetchReportingErrorClear() {
        this.props.dispatch(fetchReportingError);
    }

    errorNoDataClear() {
        this.props.dispatch(clearNoDataError);
    }

    getFilters() {
        let filters = {
            advancedFilter: $('#advanced_filter').val(),
            templateFilter: $('#template').val(),
            manufacturerFilter: $('#manufacturer').val(),
            productLineFilter: $('#product_line').val(),

            upcFilter: $('#upc').val(),
            vendorSkuFilter: $('#vendor_sku').val(),
            reicoSkuFilter: $('#reico_sku').val(),
            productNameFilter: $('#product_name').val(),
            descriptionFilter: $('#description').val(),
        }

        if (filters.advancedFilter === 'Select')
            filters.advancedFilter = '0';
        if (filters.templateFilter === 'Select')
            filters.templateFilter = '0';
        if (filters.manufacturerFilter == 'Select')
            filters.manufacturerFilter = '0';
        if (filters.productLineFilter == 'Select')
            filters.productLineFilter = '0';

        return filters
    }

    sortColumn(e) {
        let sortOrder
        let sortElement = e.target.children.length === 0 ? e.target.parentElement : e.target
        let sortBy = sortElement.id
        let sort = sortElement.children[0].className.split(' ')[1]

        if (sort === "fa-sort") {
            sortOrder = "Ascending"
            sortElement.children[0].className = "fa fa-sort-asc fa-xs"
        }
        else if (sort === "fa-sort-asc") {
            sortOrder = "Descending"
            sortElement.children[0].className = "fa fa-sort-desc fa-xs"
        }
        else {
            sortOrder = "Ascending"
            sortElement.children[0].className = "fa fa-sort-asc fa-xs"
        }

        this.setState(
            {
                page: 1,
                sortBy: sortBy,
                sortOrder: sortOrder
            }
        );

        $('th').each(function () {
            if ($(this).attr('id') !== sortElement.id) {
                $(this).removeClass("sort")
                $($(this).children()[0]).removeClass("fa-sort-asc")
                $($(this).children()[0]).removeClass("fa-sort-desc")
                $($(this).children()[0]).addClass("fa-sort")
            }
        })

        sortElement.className = "sort"

        let filters = this.getFilters()

        filters.pageIndex = 1
        filters.sortBy = sortBy
        filters.sortOrder = sortOrder

        fetchReportingList.bind(this)(filters);
    }

    enterKey(event) {
        if (event.keyCode == 13)
            this.setFilter()
    }

    setFilter(e) {
        $('th').each(function () {
            $(this).removeClass("sort")
            $($(this).children()[0]).removeClass("fa-sort-asc")
            $($(this).children()[0]).removeClass("fa-sort-desc")
            $($(this).children()[0]).addClass("fa-sort")
        })

        let filters = this.getFilters()

        filters.pageIndex = 1

        fetchReportingList.bind(this)(filters);
    }
    setFilterData(e) {
        if (e.target.id === document.getElementById("advanced_filter").id && this.state.advancedFilterChosen === false) {
            this.setState({ advancedFilterChosen: true });
        }
        else if (e.target.id === document.getElementById("advanced_filter").id && this.state.advancedFilterChosen === true) {
            $('#template').val('Select')
            $('#manufacturer').val('Select')
            $('#product_line').val('Select')

            $('#upc').val('')
            $('#vendor_sku').val('')
            $('#reico_sku').val('')
            $('#product_name').val('')
            $('#description').val('')

            if (e.target.id === document.getElementById("advanced_filter").id) {
                if (e.target.value === "0") {
                    this.setState({ advancedFilterChosen: false });
                }
            }
        }

        this.setState(
            {
                page: 1,
                sortBy: "",
                sortOrder: "Unspecified",
                templateValue: $('#template').val(),
                manufacturerValue: $('#manufacturer').val(),
                productLineValue: $('#product_line').val()
            }
        )
    }
    clearFilters() {
        $('#advanced_filter').val('Select')
        $('#template').val('Select')
        $('#manufacturer').val('Select')
        $('#product_line').val('Select')

        $('#upc').val('')
        $('#vendor_sku').val('')
        $('#reico_sku').val('')
        $('#product_name').val('')
        $('#description').val('')

        $('th').each(function () {
            $(this).removeClass("sort")
            $($(this).children()[0]).removeClass("fa-sort-asc")
            $($(this).children()[0]).removeClass("fa-sort-desc")
            $($(this).children()[0]).addClass("fa-sort")
        })

        this.setState(
            {
                advancedFilterChosen: false,
                templateValue: '0',
                manufacturerValue: '0',
                productLineValue: '0'
            }
        )

        fetchReportingList.bind(this)();
    }

    export_reporting() {
        if (this.props.reporting.fetching) return

        this.exportExcelReporting();
    }
    exportExcelReporting()
    {
        let filter = {
            advancedFilter: $('#advanced_filter').val(),
            templateFilter: $('#template').val(),
            manufacturerFilter: $('#manufacturer').val(),
            productLineFilter: $('#product_line').val(),

            upcFilter: $('#upc').val(),
            vendorSkuFilter: $('#vendor_sku').val(),
            reicoSkuFilter: $('#reico_sku').val(),
            productNameFilter: $('#product_name').val(),
            descriptionFilter: $('#description').val()
        }

        if (filter.advancedFilter === 'Select')
            filter.advancedFilter = '0';
        if (filter.templateFilter === 'Select')
            filter.templateFilter = '0';
        if (filter.manufacturerFilter == 'Select')
            filter.manufacturerFilter = '0';
        if (filter.productLineFilter == 'Select')
            filter.productLineFilter = '0';

        if (export_excel_bridge_reporting(this.props.dispatch, filter))
        {
            fetchReportingList.bind(this)(filter);
        }
    }

    loadMore() {
        if (this.props.reporting.fetching) return

        let currPage = this.state.page + 1;

        let filters = this.getFilters();

        filters.pageIndex = currPage;
        filters.sortBy = this.state.sortBy;
        filters.sortOrder = this.state.sortOrder;

        this.setState({ page: currPage });

        fetchReportingList.bind(this)(filters);
    }

    render() {
        return (
            <div className="reporting col-xs-12">
                <CommError error={this.props.reporting.error} onClose={this.fetchReportingErrorClear} />

                <ConfirmModal open={this.props.reporting.noData} heading={"Reporting"} msg={"No Records"} notifyOnly={true} onYes={this.errorNoDataClear} />

                <div className="headWrapper">
                    <div className="product">
                        <h1>Reporting</h1>
                    </div>
                </div>
                <div className="tableWrapper">
                    {
                        this.props.reporting.fetching ?
                            <Spinner name='line-spin-fade-loader' />
                        :
                            null
                    }
                    <p>Filter on:</p>
                    <div className="filters row">
                        <div className="col-xs-12 col-sm-6">
                        <div className="form-group">
                                <label>Advanced Filters:</label>
                                {
                                    this.props.reporting.fetching ?
                                        <select className="form-control" id="advanced_filter" defaultValue="Select" disabled>
                                            <option>Select</option>
                                            <option value="1">Products w/ missing images</option>
                                            <option value="2">Products w/ same Reico SKU</option>
                                            <option value="3">Products w/ same URL</option>
                                            <option value="4">Products w/ overrides</option>
                                            <option value="5">Products w/ multiple template assignments</option>
                                        </select>
                                    :
                                        <select className="form-control" id="advanced_filter" defaultValue="Select" onChange={this.setFilterData}>
                                            <option>Select</option>
                                            <option value="1">Products w/ missing images</option>
                                            <option value="2">Products w/ same Reico SKU</option>
                                            <option value="3">Products w/ same URL</option>
                                            <option value="4">Products w/ overrides</option>
                                            <option value="5">Products w/ multiple template assignments</option>
                                        </select>
                                }
                            </div>
                            <div className="form-group">
                                <label>Template:</label>
                                {
                                    this.props.reporting.fetching ?
                                        <select className="form-control" value={this.state.templateValue} id="template" defaultValue="Select" disabled>
                                            <option>Select</option>
                                            {
                                                this.props.reporting.filters.templates ?
                                                    this.props.reporting.filters.templates.sort(function (a, b) {
                                                        a = a.substr(a.indexOf('-') + 1).toLowerCase();
                                                        b = b.substr(b.indexOf('-') + 1).toLowerCase();

                                                        if (a > b) {
                                                            return 1;
                                                        }
                                                        else if (a < b) {
                                                            return -1;
                                                        }
                                                        else {
                                                            return 0;
                                                        }
                                                    })
                                                        .map((opt, index) => {
                                                            var tempid = opt.substr(0, opt.indexOf('-'));
                                                            var tempname = opt.substr(opt.indexOf('-') + 1);

                                                            return <option value={tempid} key={index}>
                                                                {tempname}
                                                            </option>;
                                                        })
                                                    :
                                                    null
                                            }
                                        </select>
                                    :
                                        <select className="form-control" value={this.state.templateValue} id="template" defaultValue="Select" onChange={this.setFilterData}>
                                            <option>Select</option>
                                            {
                                                this.props.reporting.filters.templates ?
                                                    this.props.reporting.filters.templates.sort(function (a, b) {
                                                        a = a.substr(a.indexOf('-') + 1).toLowerCase();
                                                        b = b.substr(b.indexOf('-') + 1).toLowerCase();

                                                        if (a > b) {
                                                            return 1;
                                                        }
                                                        else if (a < b) {
                                                            return -1;
                                                        }
                                                        else {
                                                            return 0;
                                                        }
                                                    })
                                                        .map((opt, index) => {
                                                            var tempid = opt.substr(0, opt.indexOf('-'));
                                                            var tempname = opt.substr(opt.indexOf('-') + 1);

                                                            return <option value={tempid} key={index}>
                                                                {tempname}
                                                            </option>;
                                                        })
                                                    :
                                                    null
                                            }
                                        </select>
                                }
                            </div>
                            <div className="form-group">
                                <label>Manufacturer Code(iSeries):</label>
                                {
                                    this.props.reporting.fetching ?
                                        <select className="form-control" id="manufacturer" value={this.state.manufacturerValue} defaultValue="Select" disabled>
                                            <option>Select</option>
                                            {
                                                this.props.reporting.filters.manufacturers ?
                                                    this.props.reporting.filters.manufacturers.sort((a, b) => a - b).map((opt, index) => {
                                                        return <option key={index}>{opt}</option>
                                                    })
                                                    :
                                                    null
                                            }
                                        </select>
                                    :
                                        <select className="form-control" id="manufacturer" value={this.state.manufacturerValue} defaultValue="Select" onChange={this.setFilterData}>
                                            <option>Select</option>
                                            {
                                                this.props.reporting.filters.manufacturers ?
                                                    this.props.reporting.filters.manufacturers.sort((a, b) => a - b).map((opt, index) => {
                                                        return <option key={index}>{opt}</option>
                                                    })
                                                    :
                                                    null
                                            }
                                        </select>
                                }
                            </div>
                            <div className="form-group">
                                <label>Line Code(iSeries):</label>
                                {
                                    this.props.reporting.fetching ?
                                        <select className="form-control" id="product_line" value={this.state.productLineValue} defaultValue="Select" disabled>
                                            <option>Select</option>
                                            {
                                                this.props.reporting.filters.productLines ?
                                                    this.props.reporting.filters.productLines.sort((a, b) => a - b).map((opt, index) => {
                                                        return <option key={index}>{opt}</option>
                                                    })
                                                    :
                                                    null
                                            }
                                        </select>
                                    :
                                        <select className="form-control" id="product_line" value={this.state.productLineValue} defaultValue="Select" onChange={this.setFilterData}>
                                            <option>Select</option>
                                            {
                                                this.props.reporting.filters.productLines ?
                                                    this.props.reporting.filters.productLines.sort((a, b) => a - b).map((opt, index) => {
                                                        return <option key={index}>{opt}</option>
                                                    })
                                                    :
                                                    null
                                            }
                                        </select>
                                }
                            </div>
                            <div className="form-group">
                                <label>UPC:</label>
                                {
                                    this.props.reporting.fetching ?
                                        <input className="form-control" id="upc" defaultValue="" disabled />
                                    :
                                        <input className="form-control" id="upc" defaultValue="" onKeyUp={this.enterKey} />
                                }
                            </div>
                            <div className="form-group button-group">
                                <div>
                                    <button className="btn btn-default" onClick={this.clearFilters}>Clear</button>
                                    <button className="btn btn-primary" onClick={this.export_reporting} >Export</button>
                                    <button className="btn btn-primary" onClick={this.setFilter}>Search</button>
                                </div>
                            </div>
                        </div>
                        <div className="col-xs-12 col-sm-6">
                            <div className="form-group">
                                <label>Vendor SKU:</label>
                                {
                                    this.props.reporting.fetching ?
                                        <input className="form-control" id="vendor_sku" defaultValue="" disabled />
                                    :
                                        <input className="form-control" id="vendor_sku" defaultValue="" onKeyUp={this.enterKey} />
                                }
                            </div>
                            <div className="form-group">
                                <label>Reico SKU:</label>
                                {
                                    this.props.reporting.fetching ?
                                        <input className="form-control" id="reico_sku" defaultValue="" disabled />
                                    :
                                        <input className="form-control" id="reico_sku" defaultValue="" onKeyUp={this.enterKey} />
                                }
                            </div>
                            <div className="form-group">
                                <label>Product Name:</label>
                                {
                                    this.props.reporting.fetching ?
                                        <input className="form-control" id="product_name" defaultValue="" disabled />
                                    :
                                        <input className="form-control" id="product_name" defaultValue="" onKeyUp={this.enterKey} />
                                }
                            </div>
                            <div className="form-group">
                                <label>Description:</label>
                                {
                                    this.props.reporting.fetching ?
                                        <input className="form-control" id="description" defaultValue="" disabled />
                                    :
                                        <input className="form-control" id="description" defaultValue="" onKeyUp={this.enterKey} />
                                }
                            </div>
                            <div className="pagination">
                            {
                                this.props.reporting.pages <= this.state.page * 100 ?
                                    <p>{this.props.reporting.pages} Results (Viewing 1-{this.props.reporting.pages} of {this.props.reporting.pages})</p>
                                :
                                    <p>{this.props.reporting.pages} Results (Viewing 1-{this.state.page * 100 > this.props.reporting.pages ? this.props.reporting.pages : this.state.page * 100} of {this.props.reporting.pages})</p>
                            }
                            </div>
                        </div>
                    </div>
                </div>
                {
                    this.props.reportingList.fetching ?
                        <Spinner name='line-spin-fade-loader' />
                    :
                        null
                }
                <span id="startExportReporting">
                    {
                        this.props.reporting.complete_export === false ?
                            <LoadingSpinner />
                        :
                            null
                    }
                </span>
                <span id="progress_bar_reporting"><strong> Export Progress: {this.props.reporting.percent_complete}%</strong>
                    <ProgressBar percentage={this.props.reporting.percent_complete} />
                </span>

                <table className="lists table table-striped">
                    <thead>
                        <tr className="head">
                            <th id="brmfg" onClick={this.sortColumn}>Manufacturer<i className="fa fa-sort fa-xs"></i></th>
                            <th id="brlin" onClick={this.sortColumn}>Line Code<i className="fa fa-sort fa-xs"></i></th>
                            <th id="brpart" onClick={this.sortColumn}>Part Number<i className="fa fa-sort fa-xs"></i></th>
                            <th id="reicoSKU" onClick={this.sortColumn}>Reico SKU<i className="fa fa-sort fa-xs"></i></th>
                            <th id="name" onClick={this.sortColumn}>Product Name<i className="fa fa-sort fa-xs"></i></th>
                            <th id="brprcod" onClick={this.sortColumn}>Product Code<i className="fa fa-sort fa-xs"></i></th>
                            <th id="brupc" onClick={this.sortColumn}>UPC<i className="fa fa-sort fa-xs"></i></th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            this.props.reportingList.map((srch, index) => {
                                return <tr className="body" key={index}>
                                    <td>{srch.brmfg}</td>
                                    <td>{srch.brlin}</td>
                                    <td>{srch.brpart}</td>
                                    <td>{srch.reicoSKU}</td>
                                    <td>{srch.name}</td>
                                    <td>{srch.brprcod}</td>
                                    <td>{srch.brupc}</td>
                                </tr>
                            })
                        }
                    </tbody>
                </table>
                {
                    this.props.reporting.pages > this.state.page * 100 ?
                        <button className="btn btn-block" onClick={this.loadMore}>Load More</button>
                    :
                        null
                }
            </div>
        );
    }
}

const mapStateToProps = state => ({
    reporting: state.reporting
});

export default connect(mapStateToProps)(Reporting)